import React      from 'react'
import moment     from 'moment'
import AnchorLink from '../../../common/AnchorLink'
import createReactClass from 'create-react-class'

const TeamName = ({
  team      = [],
  isTeamLinkActive  = false,
  isWebView = false
}) => {
  // if isTeamLinkActive is true wrap team names in anchor tag
  const teamNameText = ([
    <span key="long-name" className="long-name">{team.name || team.abbreviation}</span>,
    <abbr key="abbr" >{team.abbreviation}</abbr>
  ])
  let teamLinkComp = <AnchorLink key="n" {...team.link}>{ teamNameText }</AnchorLink>
  let defaultLinkProps = {}
  if(isWebView && team.uid !== '') {
    defaultLinkProps = { 'data-uid' : team.uid, 'className' : 'app_partial', 'data-linktype' : 'clubhouse' }
    teamLinkComp = <a key="n1" { ...defaultLinkProps }>{ teamNameText }</a>
  }
  return isTeamLinkActive ? (isWebView ? teamLinkComp : <AnchorLink key="n" {...team.link}>{ teamNameText }</AnchorLink>)
                          : <div key="n">{teamNameText}</div>
}

const TeamLogo = ({
  team      = [],
  isTeamLinkActive  = false,
  isWebView = false
}) => {
  // if isTeamLinkActive is true wrap team logos in anchor tag
  const teamLogoImg = ( <img key="tli" src={team.logo} /> )
  let teamLinkComp = <AnchorLink key="l" {...team.link}>{ teamLogoImg }</AnchorLink>
  let defaultLinkProps = {}
  if(isWebView && team.uid !== '') {
    defaultLinkProps = { 'data-uid' : team.uid, 'className' : 'app_partial', 'data-linktype' : 'clubhouse' }
    teamLinkComp = <a key="n2" { ...defaultLinkProps }>{ teamLogoImg }</a>
  }
  return isTeamLinkActive ? (isWebView ? teamLinkComp : <AnchorLink key="l2" {...team.link}>{ teamLogoImg }</AnchorLink>)
                          : teamLogoImg
}

let TableBody = createReactClass({
  render: function () {

    let data = this.props.data || []
    let tableRows = []
    let classNames = {
      W : 'win',
      L : 'loss',
      D : ''
    }
    let isWebView = this.props.isWebView

    let isTeamLinkActive = this.props.isTeamLinkActive
    data.map( function ( game, i ) {
      let gameResult = null
      if ( !this.props.head2head ) {
        gameResult = (
          <td className={classNames[game.result]}>{game.resultValue}</td>
        )
      }
      tableRows.push(
        <tr key={'game.'+i}>
          {gameResult}
          <td>
            <TeamName team={game.home} isTeamLinkActive={isTeamLinkActive} isWebView={isWebView} />
          </td>
          <td className="logo">
            <TeamLogo team={game.home} isTeamLinkActive={isTeamLinkActive} isWebView={isWebView} />
          </td>
          <td>
            <AnchorLink {...game.link}>{game.score}</AnchorLink>
          </td>
          <td className="logo">
            <TeamLogo team={game.away} isTeamLinkActive={isTeamLinkActive} isWebView={isWebView} />
          </td>
          <td>
            <TeamName team={game.away} isTeamLinkActive={isTeamLinkActive} isWebView={isWebView} />
          </td>
          <td>{moment(game.date.replace('Z','')).utcOffset(0).format('Do MMM, YYYY')}</td>
          <td>{game.league}</td>
        </tr>
      )
    }.bind(this))

    return (
      <tbody>
        {tableRows}
      </tbody>
    )
  }
})

let MatchHistory = createReactClass({

  render: function () {

    let data = this.props.data || []
    let team = this.props.team || {}
    let text = this.props.text || {}
    let teamLogo = team.logo
    let isTeamLinkActive = this.props.isTeamLinkActive
    let isWebView = this.props.isWebView

    if ( this.props.head2head ) {
      teamLogo = data && data[0] && data[0].home.logo
    }

    /* react wraps a span around the word so lets force it as it breaks the css*/
    let sDisplayTitle = this.props.head2head ? text.title : '<img src="' + teamLogo + '" />' + text.title
    return (
      <div className={'sub-module last-games soccer' + (this.props.head2head ? ' head-to-head'  :'')}>
        <header className="">
          <h1 dangerouslySetInnerHTML={ { __html: sDisplayTitle } }></h1>
        </header>
        <div className="content" style={ { overflowX: 'auto' } }>
          <table data-fix-cols="0" data-behavior="responsive_table">
            <thead>
              <tr>
                <th colSpan={ this.props.head2head ? 5 : 6 }>{ text.col1 }</th>
                <th>{ text.col2 }</th>
                <th>{ text.col3 }</th>
              </tr>
            </thead>
            {data.length ? <TableBody head2head={this.props.head2head} data={data} isTeamLinkActive={isTeamLinkActive} isWebView={isWebView} /> : <tbody><tr><td colSpan="8">No data available</td></tr></tbody>}
          </table>
        </div>
      </div>
    )
  }
})

module.exports = MatchHistory



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/components/MatchHistory.jsx